import { action, makeAutoObservable, runInAction } from "mobx";
import { Store, SettingsData, ISettingsStore } from "../global/types";
import { getSettingsData, updateSettingsData } from "../api/user.action"
import { toastManager } from "../utils/toastManager";

class SettingsStore implements ISettingsStore {
    rootStore: Store;
    settingsData!: SettingsData | null;
    error: string | null = null;
    loading: boolean = false;

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchSettingData = async () => {
        this.setLoading(true);
        try {
            const response = await getSettingsData();
            runInAction(() => {
                this.settingsData = response.data
            })
        } catch (error: unknown) {
             toastManager.handleError(error);
        } finally {
            this.setLoading(false);
        }
    }
    @action
    updateSettings = async (data: object) => {
        this.setLoading(true);
        try {
            const response = await updateSettingsData(data);
            runInAction(() => {
                this.settingsData = response.data.data;
            })
        } catch (error: unknown) {
            toastManager.handleError(error); 
        } finally {
            this.setLoading(false);
        }
    }

    resetSettingsPageDataStates = () => {
        runInAction(() => {
            this.settingsData = null
            this.error = null
            this.loading = false
        })
    }
}

export default SettingsStore;
